import { css, styled } from "styled-components";
import { Button } from "react-aria-components";
import { FloatingArrow } from "@floating-ui/react";
import { useDesignTokens } from "@boi/react-design-tokens";

type ContainerProps = {
  $isControlled: boolean;
  $maxWidth: number | undefined;
};

export const Container = styled.div<ContainerProps>`
  ${({ $isControlled, $maxWidth }) => {
    const { tokens } = useDesignTokens();
    const { tooltip } = tokens;

    return [
      css`
        max-width: ${$maxWidth ? `${$maxWidth}px` : tooltip.maxWidth};
        border-radius: ${tooltip.radius};
        padding-top: ${tooltip.padding.top};
        padding-bottom: ${tooltip.padding.bottom};
        padding-left: ${tooltip.padding.left};
        padding-right: ${tooltip.padding.right.default};
        background: ${tooltip.backgroundColor};
        z-index: ${tooltip.zIndex};
      `,
      $isControlled &&
        css`
          padding-right: ${tooltip.padding.right.large};
        `,
    ];
  }}
`;

export const Arrow = styled(FloatingArrow)`
  path {
    pointer-events: auto;
  }
`;

export const CloseButton = styled(Button)`
  ${() => {
    const { tokens } = useDesignTokens();
    const { tooltip } = tokens;

    return css`
      all: unset;
      position: absolute;
      top: 0;
      right: 0;
      display: grid;
      place-items: center;
      width: ${tooltip.closeButton.width};
      height: ${tooltip.closeButton.height};
      cursor: pointer;

      svg {
        display: block;
        width: ${tooltip.closeButton.icon.width};
        height: ${tooltip.closeButton.icon.height};
        color: ${tooltip.closeButton.icon.color.base};
        background: ${tooltip.closeButton.icon.backgroundColor.base};
        border-radius: ${tooltip.closeButton.icon.radius};
      }

      &[data-hovered] {
        svg {
          color: ${tooltip.closeButton.icon.color.hover};
          background: ${tooltip.closeButton.icon.backgroundColor.hover};
        }
      }

      &[data-pressed] {
        svg {
          color: ${tooltip.closeButton.icon.color.active};
          background: ${tooltip.closeButton.icon.backgroundColor.active};
        }
      }

      &[data-focus-visible] {
        svg {
          outline-width: ${tooltip.closeButton.icon.focusRing.width};
          outline-style: ${tooltip.closeButton.icon.focusRing.style};
          outline-color: ${tooltip.closeButton.icon.focusRing.color};
        }
      }
    `;
  }}
`;
